import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-contact-us-message',
  templateUrl: './contact-us-message.component.html',
  styleUrls: ['./contact-us-message.component.scss']
})
export class ContactUsMessageComponent implements OnInit {

  isPostLoginPage: boolean;
  constructor(private router: Router,
    private route: ActivatedRoute,) { }

  ngOnInit(): void {
    this.isPostLoginPage = this.route.snapshot.paramMap.get('isPostLoginPage')=='true';  
  }

  redirectToHomePage(){
    if(this.isPostLoginPage){
      this.router.navigate(['creditorhome']);
    }
    else{
     this.router.navigate(['']);
    }
  }

}
